import React from 'react';
import ClassAssembly11C from 'views/Class12Dance';

const ClassAssembly11CPage = () => {
    return <ClassAssembly11C />;
  };
  
  export default ClassAssembly11CPage;

  //11C